import { render, staticRenderFns } from "./menupermissionstable.vue?vue&type=template&id=f4128f9a&scoped=true&"
import script from "./menupermissionstable.vue?vue&type=script&lang=js&"
export * from "./menupermissionstable.vue?vue&type=script&lang=js&"
import style0 from "./menupermissionstable.vue?vue&type=style&index=0&id=f4128f9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4128f9a",
  null
  
)

export default component.exports